<div class="modal-body">
    <dropzone
        [config]="config"
        [message]="'Click or drag images here to upload'"
        (success)="onUploadSuccess($event)"
        (processing)="onProcessUploading()"
        (error)="attachmentService.onFailedUploading($event)"
        (queueComplete)="onFinishUploading()"
        (removedFile)="onRemovedFile($event)">
    </dropzone>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="close()" translate>Cancel</button>
    <button
        type="button"
        class="btn btn-primary"
        (click)="addAttachments()"
        [disabled]="files.length === 0 || isUploadingFiles"
        translate>
        Add attachments
    </button>
</div>
